/* Bella Tu -- THE SIGN-UP's behaviour (2026-10-09).
 *
 * One request for every sign-up on the page: BTNewsletter.subscribe() sends
 * Klaviyo's client-side subscription, and the popup (snippets/newsletter-popup
 * .liquid) calls it too, so the payload, the consent source and the API
 * revision live here once. The forms snippets/newsletter-form.liquid draws are
 * bound below: validation, a pending state, the error and the success, each
 * scoped to its own form.
 *
 * Every form is a Shopify customer form (Codex audit finding 3, 2026-10-15:
 * the Klaviyo form had no action, and a native submit put the address in the
 * page URL). A form carrying a Klaviyo key and list goes to Klaviyo, and shows
 * only once bound here (data-nl-ready; theme.css hides [data-nl-needs-script]
 * until then), so a sign-up never posts to Shopify while Klaviyo is set
 * (the user, 2026-10-16). With Klaviyo off, the form posts to Shopify as a
 * customer tagged "newsletter", with this file or without it.
 * Shopify's post returns with ?customer_posted=true (or contact_posted) and the
 * form's own #id, so a form shows its success only when the anchor is its own:
 * the popup and the footer both see form.posted_successfully?.
 */
(function () {
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function subscribe(opts) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          // Stored on the consent record, so Klaviyo can segment on where a
          // subscriber came from. A sibling of profile, not inside it.
          custom_source: opts.source,
          profile: { data: { type: 'profile', attributes: {
            email: opts.email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: opts.list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(opts.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-04-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!(res.status === 202 || res.ok)) throw new Error('Subscribe failed: ' + res.status);
      // With Klaviyo's onsite script on the page (its app embed), say who this
      // is, so their later visits count as theirs, as after a sign-up through
      // Klaviyo's own form. Without the script this does nothing.
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          var known = window.klaviyo.identify({ email: opts.email });
          if (known && typeof known.catch === 'function') known.catch(function () {});
        }
      } catch (e) {}
    });
  }

  // One attempt at a time per form, with a bounded wait (Codex audit finding 4).
  // Past the wait the sign-up may still have reached Klaviyo, so nothing is sent
  // again: the form opens up with a note (slow), and the answer, whenever it
  // comes, still lands. An answer to an attempt a newer one replaced changes
  // nothing on screen.
  function attempts() {
    var current = 0;
    return function (send, on) {
      var mine = ++current, settled = false;
      var timer = setTimeout(function () {
        if (!settled && mine === current) on.slow();
      }, window.btRequestTimeout || 15000);
      send().then(function () {
        settled = true; clearTimeout(timer);
        if (mine === current) on.ok();
      }, function (err) {
        settled = true; clearTimeout(timer);
        if (mine === current) on.fail(err);
      });
    };
  }
  window.BTNewsletter = { subscribe: subscribe, attempts: attempts, valid: function (e) { return EMAIL.test(e); } };

  function bind(root) {
    if (root.__btNl) return;
    var form = root.querySelector('form');
    var input = root.querySelector('input[type="email"]');
    var button = root.querySelector('button[type="submit"]');
    var err = root.querySelector('[data-nl-error]');
    var notice = root.querySelector('[data-nl-notice]');
    var ok = root.querySelector('[data-nl-success]');
    if (!form || !input) return;
    // The script validates with its own message; without it, the browser's
    // required/type=email checks still guard Shopify's native post.
    form.noValidate = true;

    function clearError() {
      if (err) { err.hidden = true; err.textContent = ''; }
      if (notice) { notice.hidden = true; notice.textContent = ''; }
      input.removeAttribute('aria-invalid');
    }
    // An address the form cannot use: the field is marked and takes focus.
    function showError(msg) {
      if (err) { err.textContent = msg; err.hidden = false; }
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
    // What the network said (refused, still waiting): announced by its own
    // status line, with the address left as valid and focus where it was.
    function showNotice(msg) {
      var line = notice || err;
      if (line) { line.textContent = msg; line.hidden = false; }
    }
    // After the sign-up the block says one thing (the user, 2026-10-15, as the
    // popup does): the invitation in the surrounding [data-nl-scope] marked
    // [data-nl-intro] goes with the form, and the thank-you takes its place.
    function showSuccess() {
      // A sign-up here keeps the popup away too, as a popup sign-up does
      // (snippets/newsletter-popup.liquid reads the same cookie).
      var cookie = root.getAttribute('data-popup-cookie');
      if (cookie) {
        var expires = new Date(Date.now() + (parseInt(root.getAttribute('data-popup-days'), 10) || 400) * 86400000);
        document.cookie = cookie + '=subscribed; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
      }
      form.hidden = true;
      var scope = root.closest('[data-nl-scope]');
      if (scope) scope.querySelectorAll('[data-nl-intro]').forEach(function (el) { el.hidden = true; });
      if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); }
    }
    var busy = false;
    function pending(on) {
      busy = on;
      if (button) button.disabled = on;
      form.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    var attempt = attempts();

    input.addEventListener('input', clearError);
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      var email = (input.value || '').trim();
      clearError();
      if (!EMAIL.test(email)) {
        e.preventDefault();
        showError(root.getAttribute('data-msg-invalid') || 'Please enter a valid email address.');
        return;
      }
      var key = form.getAttribute('data-key'), list = form.getAttribute('data-list');
      if (!key || !list) {
        // Shopify's form posts natively; hold the button against a double post.
        setTimeout(function () { pending(true); }, 0);
        return;
      }
      e.preventDefault();
      pending(true);
      attempt(function () {
        return subscribe({ email: email, key: key, list: list, source: form.getAttribute('data-source') });
      }, {
        ok: function () { pending(false); clearError(); showSuccess(); },
        fail: function () {
          pending(false);
          showNotice(root.getAttribute('data-msg-failed') || 'Something went wrong. Please try again.');
        },
        slow: function () {
          pending(false);
          showNotice(root.getAttribute('data-msg-slow') || 'Still waiting for confirmation. Your sign-up may still complete, or you can try again.');
        }
      });
    });

    // Bound: the form shows from here (theme.css), with its submit handler
    // already in place, and a bind that threw before this line stays hidden
    // and is tried again on the next init (Codex, review of e1af041).
    root.__btNl = true;
    root.setAttribute('data-nl-ready', '');

    // Back from Shopify's post: this form's own anchor only.
    var id = root.getAttribute('data-nl-form');
    var params = new URLSearchParams(window.location.search);
    if (id && window.location.hash === '#' + id) {
      var server = root.querySelector('[data-nl-server-error]');
      if (server) {
        var tmp = document.createElement('div');
        tmp.appendChild(server.content.cloneNode(true));
        showError((tmp.textContent || '').replace(/\s+/g, ' ').trim() || root.getAttribute('data-msg-invalid'));
      } else if (params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true') {
        showSuccess();
      }
    }
  }

  function init() { document.querySelectorAll('[data-nl-form]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
